module.exports = __webpack_public_path__ + "static/img/5.5bc79b05.jpeg";